import Vue from 'vue';
import BzbsApi from '@/core/Http/BzbsApi.js';
import { map } from 'rxjs/operators';

/**
 * @method apiCheckUser
 */
export default {
    config: function() {
        return Vue.bzbsConfig;
    },

    /**
     * @param {String} contact_number
     * @param {String} otp
     * @param {String} refcode
     */
    apiCheckUser: function(contactNumber, otp) {
        var params = {
            contact_number: contactNumber,
            otp: otp.otp,
            refcode: otp.refcode,
        };

        var url = this.config().bzbsModuleUrl + "/auth/prefill";
        return BzbsApi.connectBzbsPost(url, null, params).pipe(map((res) => {
            return res.data;
        }));
    },
    apiChangeLine: function(lineIdToken, contactNumber, otp, birthdate) {
        var params = {
            app_id: this.config().client_id,
            id_token: lineIdToken,
            contact_number: contactNumber,
            otp: otp.otp,
            refcode: otp.refcode,
            validateCode: otp.validateCode,
            birthdate: birthdate
        };

        var url = this.config().bzbsModuleUrl + "/auth/change_line";
        return BzbsApi.connectBzbsPost(url, null, params).pipe(map((res) => {
            return res.data;
        }));
    },
}
